// export const API_URL = 'http://13.232.152.117:5000'; //current url
//export const API_URL = 'http://localhost:5000';
//export const API_URL = 'https://helpdesk-stag-api-2025.hubblehox.ai';
// export const API_URL = 'https://helpdesk-api-2025.hubblehox.ai';
export const API_URL = process.env.REACT_APP_API_URL;

export const CARD_TEXTS = [
    { cardId: 1, text: "Registration Will Start Soon" },
    { cardId: 1, text: "Register Now" },
    { cardId: 1, text: "Registration Closed." },
    { cardId: 6, text: "Get Hall Ticket" },
    { cardId: 7, text: "Raise an Objection" },
    { cardId: 7, text: "Objection Tracking Closed." },
    { cardId: 8, text: "Get Score Card" },
    { cardId: 3, text: "Registration Will Start Soon" },
    { cardId: 3, text: "Register Now" },
    { cardId: 3, text: "Registration Closed." },
];

export const PUBLISHED = [
    { value: "true", label: "Yes" },
    { value: "false", label: "No" },
];